import React from "react";
import { LegalLayout, LegalBody, useLegalContent } from "../components/LegalContent";
import CookieConsent from "../components/CookieConsent";

const PrivacyPolicyPage = () => {
  const content = useLegalContent();
  return (
    <div data-testid="privacy-policy-page">
      <LegalLayout title="Privacy Policy" content={content}>
        <LegalBody text={content?.privacy_body} />
      </LegalLayout>
      <CookieConsent />
    </div>
  );
};

export default PrivacyPolicyPage;
